var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52667 13.9993L2 7.47266V8.80599C2 9.15932 2.14 9.49932 2.39333 9.74599L7.58667 14.9393C8.10667 15.4593 8.95333 15.4593 9.47333 14.9393L13.6133 10.7993C14.1333 10.2793 14.1333 9.43266 13.6133 8.91266L8.52667 13.9993Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58667 11.6067C8.10667 12.1267 8.95333 12.1267 9.47333 11.6067L13.6133 7.46667C14.1333 6.94667 14.1333 6.1 13.6133 5.58L8.42 0.386667C8.16667 0.14 7.82667 0 7.47333 0H3.33333C2.6 0 2 0.6 2 1.33333V5.47333C2 5.82667 2.14 6.16667 2.39333 6.41333L7.58667 11.6067ZM4.83333 2C5.29333 2 5.66667 2.37333 5.66667 2.83333C5.66667 3.29333 5.29333 3.66667 4.83333 3.66667C4.37333 3.66667 4 3.29333 4 2.83333C4 2.37333 4.37333 2 4.83333 2Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/Discount.19062c337800d50e9bcb9bc2ac712223.svg";
export { ForwardRef as ReactComponent };